export enum ProfilesMode {
  GRID_VIEW = 'gridView',
  PROFILE_FORM_VIEW = 'singleProfileFormView',
  SINGULAR_PROFILE_VIEW = 'singularView',
  SINGULAR_RULES_ASSOCIATION_PROFILE_VIEW = 'rulesAssociationSingleView'
}
